import type { CSSProperties } from 'react';
import { CHART_ROLE_COLORS } from '@/theme/chartPalette';

export const CHART_TOOLTIP_CONTENT_STYLE: CSSProperties = {
  backgroundColor: CHART_ROLE_COLORS.surface,
  border: '1px solid ' + CHART_ROLE_COLORS.tooltipBorder,
  borderRadius: 12,
  fontSize: 12,
};

export const CHART_TOOLTIP_LABEL_STYLE: CSSProperties = {
  color: CHART_ROLE_COLORS.tooltipLabel,
  fontWeight: 700,
};

export const CHART_TOOLTIP_ITEM_STYLE: CSSProperties = {
  color: CHART_ROLE_COLORS.tooltipText,
};

export const CHART_LEGEND_STYLE: CSSProperties = { fontSize: 11 };

export const CHART_AXIS_TICK = { fontSize: 11, fill: CHART_ROLE_COLORS.axis } as const;

export const DEFAULT_CHART_HEIGHT = 240;

type TooltipValue = number | string | ReadonlyArray<number | string> | undefined;

export function buildValueFormatter(formatValue: (value: number) => string) {
  return function formatTooltipValue(value: TooltipValue): string {
    if (value === undefined || Array.isArray(value)) {
      return '';
    }
    return formatValue(typeof value === 'number' ? value : Number(value));
  };
}

export function buildLabelFormatter(formatLabel: (value: string) => string) {
  return function formatTooltipLabel(label: unknown): string {
    if (typeof label === 'string') {
      return formatLabel(label);
    }
    return formatLabel(String(label));
  };
}
